module.exports = __webpack_public_path__ + "img/delete-icon.90241103.svg";